// Imports

import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { getStorage, setStorage} from "src/lib/storage";
import { Message } from "src/modules/noticeboard/jsx/message.jsx";
import { ImportantNotice } from "src/modules/alerts/jsx/important-notice.jsx";
import { ServiceIndicator } from "src/modules/alerts/jsx/service-indicator.jsx";
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";
import { makeDate, makeDateNow } from "src/lib/utils.js";

// Stateful components

export class Noticeboard extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            all_messages: [],
            timestamp: 0
        };

        this.updateSessionStorage = this.updateSessionStorage.bind(this);
        this.getNewMessageCount = this.getNewMessageCount.bind(this);
        this.getStandardMessages = this.getStandardMessages.bind(this);
    }

    componentDidMount() {
        var this_component = this;
        
        var storage_key = squiz['vars']['store_id'] + 'getallmessages';
        var all_messages = JSON.parse(getStorage('session', storage_key));

        if (all_messages !== null) {
            this_component.setState({
                'all_messages': all_messages['data'],
                'timestamp': all_messages['timestamp']
            });
        }
        
    }

    componentDidUpdate(prev_props, prev_state) {
        var this_component = this;
        var portal_context = this_component['context'];

        // Do a comparison of the two message objects and dont update if they are the same (Stops app from getting caught in a loop)
        if (prev_state["all_messages"] !== this_component["state"]["all_messages"]) {
            portal_context["helpers"].updateNotificationCount(this_component.getNewMessageCount());
        }
    }


    //
    // Functions
    //

    updateSessionStorage(message_id, key, value) {
        var this_component = this;
        var all_messages = this_component.state['all_messages'];
        var storage_key = squiz['vars']['store_id'] + 'getallmessages';

        if (all_messages) {
            var message_to_update = all_messages.filter(function(message) {
                return message.id === message_id;
            });
            if (message_to_update.length > 0) {
                message_to_update[0][key] = value;
                this_component.setState({
                    all_messages: all_messages
                });
                setStorage('session', storage_key, JSON.stringify({
                    timestamp: this_component.state.timestamp,
                    data: all_messages
                }));
            }
        }
    }

    getStandardMessages() {
        var this_component = this;
        var messages = this_component.state['all_messages'];

        var standard_messages = messages.filter(function(message) {
            return message.priority != 'Critical';
        });
        return standard_messages;
    }

    renderImportantNotices() {
        var this_component = this;
        var messages = this_component.state['all_messages'];

        var critical_messages = messages.filter(function(message){
            return message.priority == 'Critical';
        });

        if (critical_messages.length > 0) {
            var notices = critical_messages.map(function(message) {
                var date_format = 'D MMMM YYYY';
                var date_value = makeDate(message.displayFrom, date_format);

                return (
                    <ImportantNotice
                        key={message.id}
                        title={message.title}
                        message={message.content.message}
                        sender={message.content.sender}
                        date={date_value}
                    />
                );
            });

            return (
                <>
                    {notices}
                </>
            );
        }

    }

    sortAndGroupMessages(messages) {
        var grouped_messages = [];
        var sorted_messages = messages.sort(function(a, b) {
            return new Date(b.displayFrom) - new Date(a.displayFrom);
        });

        grouped_messages = sorted_messages.reduce(function(arr, message) {
            var date = makeDate(message['displayFrom']);
            var id = date.format('YYYY-MM');
            var label = date.format('MMMM YYYY');

            var obj_with_key = arr.filter(function(item) {
                return item.id === id;
            });
            
            if (obj_with_key.length > 0) {
                obj_with_key[0]['messages'].push(message);
            } else {
                arr.push({
                    id: id,
                    label: label,
                    messages: [].concat(message)
                });
            }
            return arr;
        }, []);

        return grouped_messages;
    }

    getNewMessageCount() {
        var messages = this.getStandardMessages();
        var count = 0;

        if (messages.length > 0) {
            messages.forEach(function(message) {
                if (!message.read) {
                    count++;
                }
            });
        }
        if (count > 99) {
            count = '99+';
        }
        return count;
    }

    renderMessages(messages) {
        var this_component = this;
        var message_list = '';
        var date_format = 'D MMMM YYYY';

        message_list = messages.map(function(message) {
            var message_date = makeDate(message.displayFrom, date_format);

            return (
                <Message
                    key={message.id}
                    id={message.id}
                    title={message.title}
                    message={message.content.message}
                    date={message_date}
                    read={message.read}
                    starred={message.important}
                    icon={message.content.icon}
                    sender={message.content.sender}
                    action={message.content.action}
                    updateSessionStorage={this_component.updateSessionStorage}
                />
            );
        });
        return message_list;
    }

    toggleAccordion(e) {
        e.preventDefault();
        var btn = e.currentTarget;

        var isExpanded = btn.getAttribute('aria-expanded') === 'true' ? true : false;
        var panel_id = btn.getAttribute('aria-controls');
        var panel = document.getElementById(panel_id);

        if (panel) {
            if (isExpanded) {
                btn.setAttribute('aria-expanded', 'false');
                panel.classList.add('collapsed');
            } else {
                btn.setAttribute('aria-expanded', 'true');
                panel.classList.remove('collapsed');
            }
        }
    }

    renderPartialNoticeboard() {
        var this_component = this;
        var portal_context = this_component['context'];
        
        var standard_messages = this.getStandardMessages();

        var latest_messages = standard_messages.sort(function(a, b) {
            return new Date(b.displayFrom) - new Date(a.displayFrom);
        }).slice(0, 3);

        var no_messages = '';
        var no_messages_title = portal_context['configuration']['system_messages']['nodata']['allMessages'];
        if (!no_messages_title) {
            no_messages_title = 'You have no messages';
        }

        var noticeboard_footer = '';

        if (standard_messages.length < 1) {
            no_messages = (
                <div className="message-notice__wrapper">
                    <div className="message-notice__icon"></div>
                    <span className="message-notice__title">{no_messages_title}</span>
                </div>
            );
        } else {
            noticeboard_footer = (
                <div className="noticeboard__footer">
                    <a href="#/noticeboard" className="noticeboard__more-link">
                        View more notices<span className="noticeboard__footer-arrow"></span>
                    </a>
                </div>
            );
        }


        return (
            <>
                {no_messages}

                <div className="noticeboard__list">
                    {this_component.renderMessages(latest_messages)}
                </div>

                {noticeboard_footer}
            </>
        );
    }

    renderFullNoticeboard() {
        var this_component = this;
        var portal_context = this_component['context'];

        var standard_messages = this.getStandardMessages();
        var grouped_messages = this.sortAndGroupMessages(standard_messages);

        var top_messages = '';
        var month_header = '';
        var noticeboard_accordions = '';
        
        var no_messages = '';
        var no_messages_title = portal_context['configuration']['system_messages']['nodata']['allMessages'];
        if (!no_messages_title) {
            no_messages_title = 'You have no messages';
        }

        if (grouped_messages.length > 0) {

            month_header = grouped_messages[0].label;

            top_messages = this_component.renderMessages(grouped_messages[0].messages);

            grouped_messages.shift();

            noticeboard_accordions = grouped_messages.map(function(group) {
                return (
                    <div
                        key={group.id}
                        className="accordion__item"
                        id={"nb-" + group.id}
                    >
                        <button
                            className="accordion__btn"
                            aria-expanded="false"
                            aria-controls={"nb-" + group.id + "__content"}
                            onClick={this_component.toggleAccordion}
                        >
                            <span className="accordion__title">{group.label}</span>
                            <span className="accordion__toggle"></span>
                        </button>
                        <div
                            className="accordion__content collapsed"
                            id={"nb-" + group.id + "__content"}
                        >
                            <div className="noticeboard__list">
                                {this_component.renderMessages(group.messages)}
                            </div>
                        </div>
                    </div>
                );
            });

        } else {
            var date_format = 'MMMM YYYY';
            month_header = makeDateNow(date_format);
            no_messages = (
                <div className="message-notice__wrapper">
                    <div className="message-notice__icon"></div>
                    <span className="message-notice__title">{no_messages_title}</span>
                </div>
            );
        }

        return (
            <>
                {no_messages}

                <div className="noticeboard__main">
                    <div className="noticeboard__list">
                        {top_messages}
                    </div>
                    <div className="accordion__wrapper">
                        {noticeboard_accordions}
                    </div>
                </div>
            </>
        );
    }



    //
    // Render
    //


    render() {
        var this_component = this;
        var portal_context = this_component['context'];
        var is_partial = this.props.type === 'partial' ? true : false;

        return (
            <div className="noticeboard__wrapper" data-ga-label="Noticeboard">
                
                {is_partial ? (
                    <>
                        <ContextualMessage id="service_indicators" />
                        <ServiceIndicator />
                        <div className="noticeboard__header">
                            <div className="noticeboard__indicators">
                                <div className="noticeboard__new">
                                    New<span className="noticeboard__count">{portal_context["notification_count"]}</span>
                                </div>
                            </div>
                        </div>
                        <ContextualMessage id="noticeboard" />
                        {this.renderImportantNotices()}
                        {this_component.renderPartialNoticeboard()}
                    </>
                ) : (
                    <>
                        <div className="noticeboard__header">
                            <div className="noticeboard__indicators">
                                <div className="noticeboard__new">
                                    New<span className="noticeboard__count">{portal_context["notification_count"]}</span>
                                </div>
                            </div>
                        </div>
                        <ContextualMessage id="noticeboard" />
                        {this.renderImportantNotices()}
                        {this_component.renderFullNoticeboard()}
                    </>
                )}
                
            </div>
            
        );
    }

};

Noticeboard.contextType = PortalContext;
